
	import ViewToolbarButton from "client/src/vue-view/view-toolbar-button.vue";
	export default {
		name: "view-toolbar",
		components: {ViewToolbarButton},
		props: {
			batchTriggers: Array
		},
		methods: {
			getTooltipProps(trigger) {
				if (trigger.tooltip) {
					// Tooltip varsa eklenmesini istediğimiz diğer özellikler
					return {
						'data-bs-toggle': 'tooltip',
						'data-bs-html': true,
						'data-bs-placement': 'top',
						'data-bs-trigger': 'hover'
					};
				}
				return {};
			},
		},
	}
